import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ListingSearchService, FavoritesService, UserService, NotificationService } from '@app/services';


@Component({
    selector: "booking-id-label",
    templateUrl: "./booking-id-label.component.html",
    styleUrls: ["./booking-id-label.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class BookingIdLabelComponent implements OnInit {
  private readonly _componentName = 'BookingIdLabelComponent';

  private _bookingId: string;

  constructor(
    private readonly notify: NotificationService,
    private readonly userService: UserService,
    private readonly favoriteService: FavoritesService
  ) {}

  ngOnInit() {}

  public get isAdmin(): boolean {
    return this.userService.isAdmin;
  }

  public get bookingId(): string {
    return this._bookingId;
  }

  @Input()
  public set bookingId(v: string) {
    this._bookingId = v;
    console.log(`${this._componentName}.bookingId set v=`, v);
  }

  public get shortenedBookingId(): string {
    if (this.bookingId) {
      return this.bookingId.slice(0, 7);
    } else {
      return null;
    }
  }
}
